<template>
  <div class="page-container">
    <div class="header">
        <div class="back">
            <r-button type="gray" @click="$router.push('/')">Back</r-button>
        </div>
        <h1>Chat With Iya</h1>
    </div>
    <div class="content">
        <r-button @click="playWelcome">Play Welcome</r-button>
    </div>
    <audio ref="audioPlayer" :src="audioSource"></audio>
  </div>
</template>

<script>

import axios from 'axios';

const api = 'http://localhost:5025'

export default {
    name: 'Chat',
    data() {
        return {
            audioSource: null
        }
    },
    methods: {
        async playWelcome() {
            try {
                const response = await axios.get(api + '/audio/welcome', {
                    responseType: 'blob'
                });
                
                this.playSound(response.data);
            } catch (error) {
                console.error('Error fetching audio file:', error);
            }
        },
        playSound(url) {
            this.audioSource = URL.createObjectURL(url);

            this.$nextTick(() => {
                this.$el.querySelector('audio').play();
            });
        }
    },
    mounted() {
        // this.playWelcome();
    }
}
</script>

<style scoped>

h1 {
    text-align: center;
}

</style>